import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ReactPaginate from 'react-paginate';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { deletePosts, fetchAllNonApprovedPosts, handleApprove } from '../../utils/PostComponents';
import { clearAllFilters, handleFilterChange, handleSearchChange, removeFilter } from '../../utils/Filter';
import { truncateDescription } from '../../utils/truncateDescritopn';
import DialogBox from '../OtherComponents/DialogBox';

const Base_Url = process.env.REACT_APP_BASE_URL;

const AdminPostsNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [openPost, setOpenPost] = useState(false);
    const [postToDelete, setPostToDelete] = useState([]);
    const [postToUpdate, setPostToUpdate] = useState([]);
    const [status, setStatus] = useState('');
    const [statusToSend, setStatusToSend] = useState('');

    const queryParams = new URLSearchParams(location.search);
    const initialPage = parseInt(queryParams.get('page')) || 1;

    const [page, setPage] = useState(initialPage);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(8);

    const [filters, setFilters] = useState({
        status: '',
        sort: '',
        search: ''
    });
    const [activeFilters, setActiveFilters] = useState({
        status: '',
        sort: '',
        search: ''
    });

    const updateUrlParams = useCallback(async (newPage, newLimit) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('page', newPage);
        searchParams.set('limit', newLimit);
        searchParams.set('search', filters.search);
        searchParams.set('status', filters.status);
        searchParams.set('sort', filters.sort);
        navigate({ search: searchParams.toString() });
    }, [location.search, navigate, filters]);

    const fetchData = useCallback(async () => {

        const data = await fetchAllNonApprovedPosts(setPosts, setTotalPages, filters, page, limit);
        let newPage = data.totalPosts > page ? page : 1;
        setPage(newPage)
        await updateUrlParams(newPage, limit);
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, [filters, page, limit, updateUrlParams]);

    useEffect(() => {
        fetchData()
    }, [fetchData]);

    const handleClose = () => {
        setOpen(false);
    };





    const handleApprovePost = async (e) => {
        await handleApprove(e, postToUpdate, statusToSend, setLoading, setPosts)
        setOpenPost(false);
        clearAllFilters(setFilters, setActiveFilters)
    }

    const handleClosePost = () => {
        setOpenPost(false);
    }

    const handleDelete = async () => {
        const res = await deletePosts(postToDelete);
        if (res) {
            toast.success(res.data.msg);
        }
        else {
            toast.err(res.data.msg)
        }
        setOpen(false);
        fetchAllNonApprovedPosts(setPosts, setTotalPages, filters, page, limit);
    };

    const handlePageChange = async (selectedPage) => {
        const newPage = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
        setPage(newPage);
        await updateUrlParams(newPage, limit);
    };

    const handleLimitChange = async (e) => {
        const newLimit = parseInt(e.target.value);
        setLimit(newLimit);
        setPage(1);
        await updateUrlParams(1, newLimit);
    };


    return (
        <>
            <div className='aligned-container'>
                <div className='custom_container'>
                <div className='top_desc'>
                    <ToastContainer />
                    <div className='heading_btn'>
                    <h2 className='heading'>All Posts</h2>

                    <div className='add-post-div'>
                        <button className='open-modal-btn' onClick={() => {
                            navigate('/add/post')
                        }}>
                            Add Post
                        </button>
                    </div>
                    </div>
                    <div className='top'>
                        <div className="filter-container">
                            <input
                                type="text"
                                placeholder="Search by title..."
                                value={filters.search}
                                onChange={(e) => { handleSearchChange(e, filters, setFilters, setActiveFilters, activeFilters) }}
                                className="search-bar"
                            />
                            <select name="status" value={filters.status} onChange={(e) => { handleFilterChange(e, filters, setFilters, setActiveFilters) }}>
                                <option value="">All Statuses</option>
                                <option value="Pending">Pending</option>
                                <option value="Approved">Approved</option>
                                <option value="Processing">Processing</option>
                                <option value="Done">Done</option>
                            </select>
                            <select name="sort" value={filters.sort} onChange={(e) => { handleFilterChange(e, filters, setFilters, setActiveFilters) }}>
                                <option value="">Default</option>
                                <option value="amountLowToHigh">Amount: Low to High</option>
                                <option value="amountHighToLow">Amount: High to Low</option>
                            </select>
                        </div>
                        <div className="active-filters">
                            {Object.keys(activeFilters).map((key) => (
                                activeFilters[key] && (
                                    <div key={key} className="filter-chip">
                                        <span>{key.charAt(0).toUpperCase() + key.slice(1)}: {activeFilters[key]}</span>
                                        <button onClick={() => removeFilter(key, filters, setFilters, setActiveFilters)}>X</button>
                                    </div>
                                )
                            ))}
                            {Object.values(activeFilters).some((filter) => filter) && (
                                <button onClick={() => { clearAllFilters(setFilters, setActiveFilters) }} className="clear-all-button">
                                    Clear All
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                {loading && (<div className="container loading-dots"><span>.</span><span>.</span><span>.</span></div>)}

                {!loading && (posts && posts.length > 0 ?
                    <div className='post-container'>
                        {posts.map(post => (
                            <div className="post-card" key={post._id}>
                                <div className='badge-div'>
                                    {Number(post.paidAmount) === Number(post.amount) && (
                                        <span className="fully-paid-badge">Fully Paid</span>
                                    )}
                                    {Number(post.paidAmount) < Number(post.amount) && (
                                        <span className="partially-paid-badge">Partially Paid</span>
                                    )}
                                </div>
                                <div className="card-image">
                                   
                                    <img
                                        src={`${Base_Url}/assets/postThumbnails/${post.attachment}`}
                                        alt="Post Img"
                                    />
                                </div>
                                <div className="card-content">
                                <h3 className='post-title'>{post.title}</h3>
                                    <p className='amount'>${post.amount}</p>
                                    <p className='description' dangerouslySetInnerHTML={{ __html: truncateDescription(post.description, 30) }} ></p>
                                    <div className="card-actions">
                                        <div className='card-actions-btn'>

                                            {post.status === 'Pending' && <button onClick={(e) => {
                                                e.preventDefault();
                                                setOpenPost(true);
                                                setStatus('approve')
                                                setStatusToSend('Approved')
                                                setPostToUpdate(post._id);
                                            }} className='donate-btn'>Approve</button>}
                                            {post.status === 'Disapproved' && <button onClick={(e) => {
                                                e.preventDefault();
                                                setOpenPost(true);
                                                setStatus('approve')
                                                setStatusToSend('Approved')
                                                setPostToUpdate(post._id);
                                            }} className='donate-btn'>Approve</button>}
                                            {post.status === 'Approved' && <button onClick={(e) => {
                                                e.preventDefault();
                                                setOpenPost(true);
                                                setStatus('disapprove')
                                                setStatusToSend('Disapproved')
                                                setPostToUpdate(post._id);
                                            }} className='donate-btn'>Disapprove</button>}
                                            {post.status === 'Processing' && <button className='donate-btn'>Processing</button>}
                                            {post.status === 'Done' && <button className='donate-btn'>Done</button>}
                                            <button
                                                className='donate-btn'
                                                onClick={() => {
                                                    navigate(`/view/post/${post._id}`);
                                                }}
                                            >
                                                View
                                            </button>
                                        </div>
                                        <div className='card-actions-btn'>
                                            <button
                                                className='donate-btn'
                                                onClick={() => {
                                                    navigate(`/edit/post/${post._id}`, {
                                                        state: { isEditing: true, post: post }
                                                    });
                                                }}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className='donate-btn'
                                                onClick={() => {
                                                    setOpen(true)
                                                    setPostToDelete(post)
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    <div className='post-container'>
                        No Posts Found
                    </div>
                    
                )}
</div>
                {!loading &&
                    (
                        <div className='blog-paginate'>
                            <div className='limit-selection'>
                                <label htmlFor="limit">Posts per page: </label>
                                <select id="limit" value={limit} onChange={handleLimitChange}>
                                    <option value={8}>8</option>
                                    <option value={12}>12</option>
                                    <option value={16}>16</option>
                                    <option value={20}>20</option>
                                </select>
                            </div>
                            {posts && posts.length > 0 && totalPages && totalPages > 1 &&
                                <ReactPaginate
                                    pageCount={totalPages}
                                    onPageChange={handlePageChange}
                                    containerClassName="pagination"
                                    previousLabel={"<"}
                                    nextLabel={">"}
                                    breakLabel={"..."}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    pageClassName={"page-item"}
                                    activeClassName={"active"}
                                    forcePage={page - 1} // Sync with current page
                                />
                            }

                        </div>


                    )}
                {open &&
                    <DialogBox
                        open={open}
                        handleClose={handleClose}
                        handleAction={handleDelete}
                        action={postToDelete}
                        item={'post'}
                    />
                }

                {openPost &&
                    <DialogBox
                        open={openPost}
                        handleClose={handleClosePost}
                        handleAction={handleApprovePost}
                        action={postToUpdate}
                        item={'post'}
                        status={status}
                    />
                }

            </div>
        </>
    );
};

export default AdminPostsNav;
